import _                   from 'lodash'
import moment              from 'moment';
import Immutable           from 'immutable';
import { datesInInterval } from 'alto-utils/lib/utils';

export default class GroupMenu {
  constructor(canteen, date, group, _courseMenus, _menu) {
    this.canteen      = canteen;
    this.date         = date;
    this.group        = group;
    this._menu        = _menu;
    this._courseMenus = _courseMenus;
  }

  courseMenus() {
    return this._courseMenus.valueSeq();
  }

  hasMoreThanOneCourse() {
    return this._courseMenus && (this._courseMenus.size > 1);
  }

  isLocked() {
    return this.isAfterDeadline();
  }

  isAfterDeadline() {
    if (_.isNil(this.__isAfterDeadline)) {
      this.__isAfterDeadline = this._isAfterDeadline();
    }

    return this.__isAfterDeadline;
  }

  _isAfterDeadline() {
    const servedAt      = this.group.servedAtOn(this.date);
    const naiveLockedAt = servedAt.clone().subtract(this.group.lockBefore);

    // naiveLockedAt may be later then realLockedAt, but never earlier
    if (moment().isAfter(naiveLockedAt)) { return true; }

    // the rest of the method is about skipping empty days when computing lockedAt, so if
    // skipEmptyDays is disabled, we can return false because we've already checked that
    // now < naiveLockedAt
    if (!this._menu.settings.locking.skipEmptyDays) { return false; }

    const datesBtwNLAandServedAt = Immutable.List(datesInInterval(naiveLockedAt, servedAt)).butLast();

    // if datesBtwNLAandServedAt is [], naiveLockedAt and servedAt are on the same date,
    // so naiveLockedAt is reliable and we've already checked that now < naiveLockedAt
    if (!datesBtwNLAandServedAt.size) { return false; }

    const workingDaysBeforeServedAt = this._menu.datesWithMeals().filter(date => date.isBefore(this.date));

    // we need to go back datesBtwNLAandServedAt.size working days,
    // but there may not be enough of those before servedAt
    if (datesBtwNLAandServedAt.size > workingDaysBeforeServedAt.size) { return true; }

    // lockBefore duration relative to midnight before servedAt
    // - this must be positive, otherwise datesBtwNLAandServedAt would be [] above
    const lockBeforeMidnight = this.group.lockBefore.clone().subtract(this.group.servedAt);

    // if we got here, this is btw 1 and workingDaysBeforeServedAt.size
    const lockWDaysBefore = Math.ceil(lockBeforeMidnight.asDays());

    const realLockedAtStartOfDay = workingDaysBeforeServedAt.get(-lockWDaysBefore);

    const lockBeforeRLAEndOfDay = lockBeforeMidnight.clone()
      .subtract(Math.floor(lockBeforeMidnight.asDays()), 'days');

    const realLockedAt = realLockedAtStartOfDay.clone().add(1, 'day').subtract(lockBeforeRLAEndOfDay);

    return moment().isAfter(realLockedAt);
  }

  additionalMealsExistFor(meal) {
    return this._courseMenus.get(meal.additionalCourseName);
  }

  static mealsWithAdditionalCourseExist(courseName, courseMenus) {
    return !!this.mealsWithAdditionalCourse(courseName, courseMenus).size;
  }

  static mealsWithAdditionalCourse(courseName, courseMenus) {
    return this.allMeals(courseMenus).filter(meal => meal.additionalCourseName === courseName);
  }

  static allMeals(courseMenus) {
    const reducer = (meals, courseMenu) =>
      meals ? meals.concat(courseMenu.meals) : courseMenu.meals;

    return courseMenus.reduce(reducer, null);
  }
}
